import { useState } from "react";
import { useAppContext } from "../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../controller/article/ArticleController";
import { handleErrorMessage, useEffectOnce } from "../../utils/Utils";

interface TransferListServiceType {
  not: any;
  intersection: any;
  handleToggle: any;
  left: any;
  setLeft: any;
}

interface KeywordsType {
  id: number;
  keyword: string;
}

export default function TransferListService(): TransferListServiceType {
  const { showMessage } = useAppContext();
  const { axiosGetKeywords }: ArticleControllerType = ArticleController();
  const [left, setLeft] = useState<KeywordsType[]>([]);

  useEffectOnce(() => {
    getKeywords();
  });

  const not = (a: any, b: any) => {
    return a.filter((value: any) => b.indexOf(value) === -1);
  };

  const intersection = (a: any, b: any) => {
    return a.filter((value: any) => b.indexOf(value) !== -1);
  };

  const handleToggle = (checked: any, setChecked: any, value: any) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const getKeywords = () => {
    axiosGetKeywords()
      .then((result: any) => {
        setLeft(result.data);
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  return { not, intersection, handleToggle, left, setLeft };
}

export type { TransferListServiceType, KeywordsType };
